import React from 'react';
import Statistics from './Statistics/Statistics';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import InformUser from './InformUser/InformUser';
import Charts from './Charts/Charts';
import Reports from './Reports/Reports';
import Welcome from './Welcome';
import useRules from '../../../../../hooks/useRules';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    '&>*:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const Admin = () => {
  const classes = useStyles();
  const [rules,hasRule,isAdmin] = useRules();

  return (
    <div className={classes.root}>
      {!isAdmin && <Welcome />}
      {hasRule("dashboard_top_buttons") && <Statistics />}
      {hasRule("dashboard_sms_notification") && <InformUser />}
      {hasRule("dashboard_point_chart") && <Charts />}
      {hasRule('dashboard_daily_reports') && <Reports />}
    </div>
  );
};

export default React.memo(Admin);
